import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceCustomerCrossReference extends Layout {
    sourceInvoiceCrossReference: DataSource;
    textboxCustomerId: Textbox;
    textboxEdiLocation: Textbox;
}
